"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunk7ZPN562Ocjs = require('./chunk-7ZPN562O.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_2/LpAccount/LpAccountV2_2.ts
var LpAccountV2_2 = (_class = class extends _chunk7ZPN562Ocjs.LpAccountV2_1 {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v2_2}
}, _class.__initStatic(), _class);



exports.LpAccountV2_2 = LpAccountV2_2;
//# sourceMappingURL=chunk-3SFKQNZA.cjs.map